import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /**
   * An ISO 8691-serialized timestamp.
   * For example: "2020-05-11T11:44:21.638Z"
   */
  Time: { input: any; output: any }
}

export enum AggregationInterval {
  Day = "DAY",
  Month = "MONTH",
  Week = "WEEK",
  WholeDateSpan = "WHOLE_DATE_SPAN",
  Year = "YEAR",
}

export type ComparedTo = {
  __typename?: "ComparedTo"
  /** How the comparison should work */
  comparison: Comparison
  /** Whether the comparison should be relative instead of absolute */
  relative?: Maybe<Scalars["Boolean"]["output"]>
}

/** Exactly one of the fields in this type should be filled in */
export type Comparison = {
  __typename?: "Comparison"
  /** The time span of the comparison */
  interval?: Maybe<TimeComparisonInterval>
  /** The metric to compare to */
  metric?: Maybe<Scalars["String"]["output"]>
}

export type CountShipmentLegsRequest = {
  /** The date span to get shipment legs for */
  dateSpan?: InputMaybe<ShipmentDateSpan>
  /** The properties to filter the shipment legs on */
  filters?: InputMaybe<Array<InputFilterSelection>>
  /** Pagination for the query */
  groupBy?: InputMaybe<Scalars["String"]["input"]>
}

export type CountShipmentLegsResponse = {
  __typename?: "CountShipmentLegsResponse"
  /** The shipment legs the user has searched for */
  groupCounts: Array<GroupCount>
}

export type CreateReportRequest = {
  /** The description of the report */
  description?: InputMaybe<Scalars["String"]["input"]>
  /** The display name of the report */
  displayName: Scalars["String"]["input"]
  /** metrics that the report includes */
  metrics: Array<InputMetricConfiguration>
}

export type Date = {
  __typename?: "Date"
  day: Scalars["Int"]["output"]
  month: Scalars["Int"]["output"]
  year: Scalars["Int"]["output"]
}

export type DateInput = {
  day: Scalars["Int"]["input"]
  month: Scalars["Int"]["input"]
  year: Scalars["Int"]["input"]
}

export type DateSpan = {
  /** End date of the time span, exclusive. */
  endDate?: InputMaybe<DateInput>
  /** Start date of the date span, inclusive. */
  startDate?: InputMaybe<DateInput>
}

export enum DateSpanInterval {
  AllTime = "ALL_TIME",
  Custom = "CUSTOM",
  LastMonth = "LAST_MONTH",
  LastQuarter = "LAST_QUARTER",
  LastWeek = "LAST_WEEK",
  LastYear = "LAST_YEAR",
  ThisMonth = "THIS_MONTH",
  ThisQuarter = "THIS_QUARTER",
  ThisWeek = "THIS_WEEK",
  ThreeYearsAgo = "THREE_YEARS_AGO",
  TwoYearsAgo = "TWO_YEARS_AGO",
  YearToDate = "YEAR_TO_DATE",
}

export type DateTime = {
  __typename?: "DateTime"
  day: Scalars["Int"]["output"]
  hours: Scalars["Int"]["output"]
  minutes: Scalars["Int"]["output"]
  month: Scalars["Int"]["output"]
  seconds: Scalars["Int"]["output"]
  year: Scalars["Int"]["output"]
}

export type Datum = {
  __typename?: "Datum"
  /** Date of the data point */
  date: Date
  /**
   * Key of the data point. For example a timestamp.
   * @deprecated use date instead
   */
  key: Scalars["String"]["output"]
  /** All data points for a specific key separated by group. */
  values: Array<GroupedValue>
}

export type DeleteReportRequest = {
  /** Report resource name to delete */
  name: Scalars["ID"]["input"]
}

export type DuplicateReportRequest = {
  /** The display name of the new report */
  displayName: Scalars["String"]["input"]
  /** The resource name of the report to duplicate */
  name: Scalars["ID"]["input"]
}

export type FilterAttributeTerms = {
  __typename?: "FilterAttributeTerms"
  /** A filter attribute */
  filterAttributeId: Scalars["String"]["output"]
  /** Filter terms for a given filter attribute */
  filterTerms: Array<FilterTerm>
}

export type FilterByRange = {
  __typename?: "FilterByRange"
  startMonth: Scalars["Int"]["output"]
  /** Start date of the filter. */
  startYear: Scalars["Int"]["output"]
}

export type FilterByRangeRequest = {
  /** The resource name of the space to get data from. */
  organization: Scalars["ID"]["input"]
}

export type FilterSelection = {
  __typename?: "FilterSelection"
  filterAttributeId: Scalars["String"]["output"]
  filterTermIds: Array<Scalars["String"]["output"]>
}

export type FilterTerm = {
  __typename?: "FilterTerm"
  /** A human readable display name of the filter term */
  displayName: Scalars["String"]["output"]
  /** The filter term id to set in requests to the API. */
  id: Scalars["String"]["output"]
}

export type FilterTermsRequest = {
  /** The filter attributes to get available filter terms for. */
  filterAttributes: Array<Scalars["String"]["input"]>
  /** The metric id to get filter terms for. */
  metric: Scalars["String"]["input"]
  /** Organization to request from. */
  organization: Scalars["String"]["input"]
}

export type GetAvailableMetricsRequest = {
  /** The resource name of organization space to get data from. */
  organization: Scalars["ID"]["input"]
}

export type GetReportRequest = {
  /** Report resource name to get */
  name: Scalars["ID"]["input"]
}

export type GroupCount = {
  __typename?: "GroupCount"
  /** The amount of shipment legs in this group */
  count: Scalars["Int"]["output"]
  /** The group the count is for, or unset if no groupBy was specified */
  group?: Maybe<Scalars["String"]["output"]>
}

export type GroupedValue = {
  __typename?: "GroupedValue"
  /** the group that the data point is grouped on. */
  group: Scalars["String"]["output"]
  /** Value of the grouping. */
  value: Scalars["Float"]["output"]
}

export type InputComparedTo = {
  /** How the comparison should work */
  comparison: InputComparison
  /** Whether the comparison should be relative instead of absolute */
  relative?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Exactly one of the fields in this type should be filled in */
export type InputComparison = {
  /** The time span of the comparison */
  interval?: InputMaybe<TimeComparisonInterval>
  /** The metric to compare to */
  metric?: InputMaybe<Scalars["String"]["input"]>
}

export type InputFilterSelection = {
  filterAttributeId: Scalars["String"]["input"]
  filterTermIds: Array<Scalars["String"]["input"]>
}

export type InputMetricConfiguration = {
  /** Interval to aggregate the data on */
  aggregationInterval: AggregationInterval
  /** Which comparison is enabled for the metric */
  comparedTo?: InputMaybe<InputComparedTo>
  /** DateSpan of the metric */
  datespan: InputMetricDateSpan
  /** What properties to filter the metric on */
  filterSelection?: InputMaybe<Array<InputFilterSelection>>
  /** Group attribute id of the metric. For example 'lane' or 'vehicle' */
  groupAttributeId?: InputMaybe<Scalars["String"]["input"]>
  /** Whether group values should be shown as percentage share of total instead of absolute */
  groupsAsShareOfTotal?: InputMaybe<Scalars["Boolean"]["input"]>
  /** Metric id */
  metricId: Scalars["String"]["input"]
  /** Which groups are selected to be shown */
  selectedGroups?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** Unit of the metric */
  unit: Scalars["String"]["input"]
  /** How to visualize the metric */
  visualization?: InputMaybe<Visualization>
}

export type InputMetricDateSpan = {
  /** End date of the date span. Will only be set when key is set to CUSTOM. */
  endDate?: InputMaybe<DateInput>
  /** A key representing a relative datespan */
  interval: DateSpanInterval
  /** Start date of the date span. Will only be set when key is set to CUSTOM. */
  startDate?: InputMaybe<DateInput>
}

export type Metric = {
  __typename?: "Metric"
  /** The available filter attribute ids for this metric */
  availableFilterAttributeIds: Array<Scalars["String"]["output"]>
  /** The available grouping attributes for this metric */
  availableGroupAttributeIds: Array<Scalars["String"]["output"]>
  /** Metrics available for comparison with this metric */
  comparisons: Array<Scalars["String"]["output"]>
  /** The metric id */
  metricId: Scalars["String"]["output"]
  /** The type of the metric */
  metricType: MetricType
  /** The metric unit */
  unit: Scalars["String"]["output"]
}

export type MetricConfiguration = {
  __typename?: "MetricConfiguration"
  /** Interval to aggregate the data on */
  aggregationInterval: AggregationInterval
  /** Which comparison is enabled for the metric */
  comparedTo?: Maybe<ComparedTo>
  /** DateSpan of the metric */
  datespan: MetricDateSpan
  /** What properties to filter the metric on */
  filterSelection?: Maybe<Array<FilterSelection>>
  /** Group attribute id of the metric. For example 'lane' or 'vehicle' */
  groupAttributeId?: Maybe<Scalars["String"]["output"]>
  /** Whether group values should be shown as percentage share of total instead of absolute */
  groupsAsShareOfTotal?: Maybe<Scalars["Boolean"]["output"]>
  /** Metric id */
  metricId: Scalars["String"]["output"]
  /** Which groups are selected to be shown */
  selectedGroups: Array<Scalars["String"]["output"]>
  /** Unit of the metric */
  unit: Scalars["String"]["output"]
  /** How to visualize the metric */
  visualization: Visualization
}

export type MetricDateSpan = {
  __typename?: "MetricDateSpan"
  /** End date of the date span. Will only be set when key is set to CUSTOM. */
  endDate?: Maybe<Date>
  /** A key representing a relative datespan */
  interval: DateSpanInterval
  /** Start date of the date span. Will only be set when key is set to CUSTOM. */
  startDate?: Maybe<Date>
}

export enum MetricType {
  /** The metric is a ratio of values */
  Ratio = "RATIO",
  /** The metric is a sum of values */
  Sum = "SUM",
}

export type Mutation = {
  __typename?: "Mutation"
  /** Create a new report */
  CreateReport: Report
  /** Delete a report */
  DeleteReport: Report
  /** Duplicate a report */
  DuplicateReport: Report
  /** Share a report */
  ShareReport: Scalars["String"]["output"]
  /** Edit a report */
  UpdateReport: Report
}

export type MutationCreateReportArgs = {
  input: CreateReportRequest
}

export type MutationDeleteReportArgs = {
  input: DeleteReportRequest
}

export type MutationDuplicateReportArgs = {
  input: DuplicateReportRequest
}

export type MutationShareReportArgs = {
  input: ShareReportRequest
}

export type MutationUpdateReportArgs = {
  input: UpdateReportRequest
}

export type OrderBy = {
  attributeId: Scalars["String"]["input"]
  descending?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Information about pagination. */
export type PageInfo = {
  __typename?: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["ID"]["output"]>
  /** When paginating forwards, are the more items? */
  hasNextPage: Scalars["Boolean"]["output"]
}

export type PaginationInput = {
  /**
   * Returns the elements in the list that come after the specified cursor.
   * If left empty, the returned elements are from the start of the list.
   */
  after?: InputMaybe<Scalars["String"]["input"]>
  /**
   * The number of elements to return.
   * If both `after` and `first` is set, returns the _n_ first elements
   * in the list, after the element specified by `after`.
   */
  first: Scalars["Int"]["input"]
}

export type Query = {
  __typename?: "Query"
  /** Get the amount of shipment legs grouped by an attribute */
  CountShipmentLegs: CountShipmentLegsResponse
  /** Query metrics data. */
  QueryData: QueryData
  /** Get report by ID */
  Report: Report
  SearchReports: SearchReportsResponse
  /** Get a list of shipment legs */
  SearchShipmentLegs: SearchShipmentLegsResponse
  /** Get a list of available metrics */
  availableMetrics: Array<Metric>
  /** Get filter options by range */
  filterByRange?: Maybe<FilterByRange>
  /** Get a list of available filter terms for a metric */
  filterTerms: Array<FilterAttributeTerms>
  listTemplateReports: Array<Report>
}

export type QueryCountShipmentLegsArgs = {
  request: CountShipmentLegsRequest
}

export type QueryQueryDataArgs = {
  request: QueryDataRequest
}

export type QueryReportArgs = {
  request: GetReportRequest
}

export type QuerySearchReportsArgs = {
  request: SearchReportsRequest
}

export type QuerySearchShipmentLegsArgs = {
  request: SearchShipmentLegsRequest
}

export type QueryAvailableMetricsArgs = {
  request: GetAvailableMetricsRequest
}

export type QueryFilterByRangeArgs = {
  request: FilterByRangeRequest
}

export type QueryFilterTermsArgs = {
  request: FilterTermsRequest
}

export type QueryData = {
  __typename?: "QueryData"
  data: Array<Datum>
}

export type QueryDataRequest = {
  /**
   * Interval to aggregate the data on.
   * For example "MONTH" will aggregate all returned data per month.
   */
  aggregationInterval: AggregationInterval
  /**
   * Date span of the returned data.
   * Start date is inclusive while end date is exclusive.
   */
  dateSpan: DateSpan
  /** Optional filters of the metric data. */
  filterSelection?: InputMaybe<Array<QueryFilter>>
  /**
   * Optional grouping of the metric data.
   * For example: 'space_id'.
   */
  groupAttributeId?: InputMaybe<Scalars["String"]["input"]>
  /** ID of the metric to query data on. */
  metric: Scalars["String"]["input"]
  /** Organization to request data from. */
  organization: Scalars["String"]["input"]
}

export type QueryFilter = {
  /** Filter attribute id. For example 'country'. */
  filterAttributeId: Scalars["String"]["input"]
  /** Filter term ids to filter on. For example 'sweden' or 'usa' */
  filterTermIds: Array<Scalars["String"]["input"]>
}

export type Report = {
  __typename?: "Report"
  /** The time the dashboard was created */
  createTime: Scalars["Time"]["output"]
  /** The description of the report */
  description?: Maybe<Scalars["String"]["output"]>
  /** The display name of the report */
  displayName: Scalars["String"]["output"]
  /** metrics that the report includes */
  metrics: Array<MetricConfiguration>
  /** The resource name of the report */
  name: Scalars["ID"]["output"]
  /** Indicates if the report is a template report */
  template: Scalars["Boolean"]["output"]
  /** The time the dashboard was last updated */
  updateTime: Scalars["Time"]["output"]
}

export enum ReportAccessLevel {
  Owner = "OWNER",
}

export type SearchReportsRequest = {
  /** Pagination for the query */
  pagination: PaginationInput
}

export type SearchReportsResponse = {
  __typename?: "SearchReportsResponse"
  /** Pagination for the query */
  pagination: PageInfo
  /** The reports the user has access to */
  reports: Array<Report>
}

export type SearchShipmentLegsRequest = {
  /** The date span to get shipment legs for */
  dateSpan?: InputMaybe<ShipmentDateSpan>
  /** The properties to filter the shipment legs on */
  filters?: InputMaybe<Array<InputFilterSelection>>
  /** The fields to order the shipment legs by */
  orderBy?: InputMaybe<Array<OrderBy>>
  /** Pagination for the query */
  pagination: PaginationInput
}

export type SearchShipmentLegsResponse = {
  __typename?: "SearchShipmentLegsResponse"
  /** Pagination for the query */
  pagination: PageInfo
  /** The shipment legs the user has searched for */
  shipmentLegs: Array<ShipmentLeg>
}

export type ShareReportRequest = {
  /** Report resource name to share */
  name: Scalars["ID"]["input"]
  /** List of scopes to share with */
  scopes: Array<SharingScope>
}

/** Exactly one of the fields in this type should be filled in */
export type ShareWith = {
  /** An organization the report should be shared with */
  organization?: InputMaybe<Scalars["String"]["input"]>
  /** A user the report should be shared with */
  organizationUser?: InputMaybe<Scalars["String"]["input"]>
}

export type SharingScope = {
  /** At which level the report should be shared */
  accessLevel: ReportAccessLevel
  /** What entity the report should be shared with */
  shareWith: ShareWith
}

export type ShipmentDateSpan = {
  /** End date of the time span, exclusive. */
  endDate?: InputMaybe<DateInput>
  /** Start date of the date span, inclusive. */
  startDate?: InputMaybe<DateInput>
}

export type ShipmentLeg = {
  __typename?: "ShipmentLeg"
  /** The display name of the delivery vehicle used for the shipment leg */
  deliveredByVehicleDisplayName?: Maybe<Scalars["String"]["output"]>
  /** The time the delivery was reported completed, or, if exact time is unknown, the date it was reported completed */
  deliveryReportedCompleteAt?: Maybe<TimestampOrDate>
  /** The date the delivery was reported completed */
  deliveryReportedCompleteDate?: Maybe<Date>
  /** The time the delivery was reported completed */
  deliveryReportedCompleteTime?: Maybe<Scalars["Time"]["output"]>
  /** The time the delivery was reported completed in the destination timezone */
  deliveryReportedCompleteTimeLocalTimezone?: Maybe<DateTime>
  /** The destination city of the shipment leg */
  destinationCity?: Maybe<Scalars["String"]["output"]>
  /** The destination country code of the shipment leg */
  destinationCountryCode?: Maybe<Scalars["String"]["output"]>
  /** The display name of the destination of the shipment leg */
  destinationLocationDisplayName?: Maybe<Scalars["String"]["output"]>
  /** The destination of the shipment leg */
  destinationLocationId?: Maybe<Scalars["String"]["output"]>
  /** Postal code of the shipment leg destination location */
  destinationPostalCode?: Maybe<Scalars["String"]["output"]>
  /** The display name of the lane of the shipment leg */
  laneDisplayName?: Maybe<Scalars["String"]["output"]>
  /** The lane of the shipment leg */
  laneId?: Maybe<Scalars["String"]["output"]>
  /** The resource name of the shipment leg */
  name: Scalars["String"]["output"]
  /** The origin city of the shipment leg */
  originCity?: Maybe<Scalars["String"]["output"]>
  /** The origin country code of the shipment leg */
  originCountryCode?: Maybe<Scalars["String"]["output"]>
  /** The display name of the origin of the shipment leg */
  originLocationDisplayName?: Maybe<Scalars["String"]["output"]>
  /** The origin of the shipment leg */
  originLocationId?: Maybe<Scalars["String"]["output"]>
  /** Postal code of the shipment leg origin location */
  originPostalCode?: Maybe<Scalars["String"]["output"]>
  /** The owner organization of the shipment leg */
  ownerOrganizationName?: Maybe<Scalars["String"]["output"]>
  /** The shipment this shipment leg is a part of */
  shipment: Scalars["String"]["output"]
  /** Shipment reference used by customer */
  shipmentExternalReferenceId?: Maybe<Scalars["String"]["output"]>
  /** Time when shipment was released (UTC timezone) */
  shipmentReleaseTime?: Maybe<Scalars["Time"]["output"]>
  /** The space this shipment leg is a part of */
  space: Scalars["String"]["output"]
  /** The display name of the space this shipment leg is a part of */
  spaceDisplayName?: Maybe<Scalars["String"]["output"]>
  /** The status of the shipment leg */
  status?: Maybe<Scalars["String"]["output"]>
  /** The drive type of the vehicle used for the shipment leg */
  vehicleDriveType?: Maybe<Scalars["String"]["output"]>
  /** The energy source of the vehicle used for the shipment leg */
  vehicleEnergySource?: Maybe<Scalars["String"]["output"]>
}

export enum TimeComparisonInterval {
  LastYear = "LAST_YEAR",
  PreviousPeriod = "PREVIOUS_PERIOD",
}

export type TimestampOrDate = {
  __typename?: "TimestampOrDate"
  /** The date the delivery was reported completed. Only populated if timestamp is null */
  date?: Maybe<Date>
  /** The time the delivery was reported completed */
  timestamp?: Maybe<Scalars["Time"]["output"]>
}

export type UpdateReportRequest = {
  /** The description of the report */
  description: Scalars["String"]["input"]
  /** The display name of the report */
  displayName: Scalars["String"]["input"]
  /** metrics that the report includes */
  metrics: Array<InputMetricConfiguration>
  /** The name of the report */
  name: Scalars["ID"]["input"]
}

export enum Visualization {
  BarGraph = "BAR_GRAPH",
  LineGraph = "LINE_GRAPH",
  Metric = "METRIC",
  Rank = "RANK",
}

export type FilterFragment = { __typename?: "FilterByRange"; startYear: number; startMonth: number }

export type FilterByRangeQueryVariables = Exact<{
  request: FilterByRangeRequest
}>

export type FilterByRangeQuery = {
  __typename?: "Query"
  filters?: { __typename?: "FilterByRange"; startYear: number; startMonth: number } | null
}

export type ReportDatumFragment = {
  __typename?: "Datum"
  key: string
  values: Array<{ __typename?: "GroupedValue"; group: string; value: number }>
}

export type QueryDataQueryVariables = Exact<{
  request: QueryDataRequest
}>

export type QueryDataQuery = {
  __typename?: "Query"
  QueryData: {
    __typename?: "QueryData"
    data: Array<{
      __typename?: "Datum"
      key: string
      values: Array<{ __typename?: "GroupedValue"; group: string; value: number }>
    }>
  }
}

export type FilterTermFragment = { __typename?: "FilterTerm"; id: string; displayName: string }

export type FilterAttributeTermsFragment = {
  __typename?: "FilterAttributeTerms"
  filterAttributeId: string
  filterTerms: Array<{ __typename?: "FilterTerm"; id: string; displayName: string }>
}

export type FilterTermsQueryVariables = Exact<{
  request: FilterTermsRequest
}>

export type FilterTermsQuery = {
  __typename?: "Query"
  filterTerms: Array<{
    __typename?: "FilterAttributeTerms"
    filterAttributeId: string
    filterTerms: Array<{ __typename?: "FilterTerm"; id: string; displayName: string }>
  }>
}

export type DateSpanFragment = {
  __typename?: "MetricDateSpan"
  interval: DateSpanInterval
  startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
  endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
}

export type ComparisonFragment = {
  __typename?: "Comparison"
  interval?: TimeComparisonInterval | null
  metric?: string | null
}

export type ReportFragment = {
  __typename?: "Report"
  name: string
  displayName: string
  description?: string | null
  template: boolean
  metrics: Array<{
    __typename?: "MetricConfiguration"
    groupAttributeId?: string | null
    metricId: string
    unit: string
    visualization: Visualization
    groupsAsShareOfTotal?: boolean | null
    aggregationInterval: AggregationInterval
    selectedGroups: Array<string>
    filterSelection?: Array<{
      __typename?: "FilterSelection"
      filterAttributeId: string
      filterTermIds: Array<string>
    }> | null
    comparedTo?: {
      __typename?: "ComparedTo"
      relative?: boolean | null
      comparison: {
        __typename?: "Comparison"
        interval?: TimeComparisonInterval | null
        metric?: string | null
      }
    } | null
    datespan: {
      __typename?: "MetricDateSpan"
      interval: DateSpanInterval
      startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
    }
  }>
}

export type ReportQueryVariables = Exact<{
  request: GetReportRequest
}>

export type ReportQuery = {
  __typename?: "Query"
  Report: {
    __typename?: "Report"
    name: string
    displayName: string
    description?: string | null
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      groupAttributeId?: string | null
      metricId: string
      unit: string
      visualization: Visualization
      groupsAsShareOfTotal?: boolean | null
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
    }>
  }
}

export type CreateReportMutationVariables = Exact<{
  input: CreateReportRequest
}>

export type CreateReportMutation = {
  __typename?: "Mutation"
  CreateReport: {
    __typename?: "Report"
    name: string
    displayName: string
    description?: string | null
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      groupAttributeId?: string | null
      metricId: string
      unit: string
      visualization: Visualization
      groupsAsShareOfTotal?: boolean | null
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
    }>
  }
}

export type UpdateReportMutationVariables = Exact<{
  input: UpdateReportRequest
}>

export type UpdateReportMutation = {
  __typename?: "Mutation"
  UpdateReport: {
    __typename?: "Report"
    name: string
    displayName: string
    description?: string | null
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      groupAttributeId?: string | null
      metricId: string
      unit: string
      visualization: Visualization
      groupsAsShareOfTotal?: boolean | null
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
    }>
  }
}

export type DuplicateReportMutationVariables = Exact<{
  input: DuplicateReportRequest
}>

export type DuplicateReportMutation = {
  __typename?: "Mutation"
  DuplicateReport: {
    __typename?: "Report"
    name: string
    displayName: string
    description?: string | null
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      groupAttributeId?: string | null
      metricId: string
      unit: string
      visualization: Visualization
      groupsAsShareOfTotal?: boolean | null
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
    }>
  }
}

export type DeleteReportMutationVariables = Exact<{
  input: DeleteReportRequest
}>

export type DeleteReportMutation = {
  __typename?: "Mutation"
  DeleteReport: {
    __typename?: "Report"
    name: string
    displayName: string
    description?: string | null
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      groupAttributeId?: string | null
      metricId: string
      unit: string
      visualization: Visualization
      groupsAsShareOfTotal?: boolean | null
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
    }>
  }
}

export type MetricFragment = {
  __typename?: "Metric"
  metricId: string
  availableGroupAttributeIds: Array<string>
  availableFilterAttributeIds: Array<string>
  unit: string
  comparisons: Array<string>
  metricType: MetricType
}

export type AvailableMetricsQueryVariables = Exact<{
  request: GetAvailableMetricsRequest
}>

export type AvailableMetricsQuery = {
  __typename?: "Query"
  availableMetrics: Array<{
    __typename?: "Metric"
    metricId: string
    availableGroupAttributeIds: Array<string>
    availableFilterAttributeIds: Array<string>
    unit: string
    comparisons: Array<string>
    metricType: MetricType
  }>
}

export type DateFragment = { __typename?: "Date"; year: number; month: number; day: number }

export type ReportMetricConfigurationFragment = {
  __typename?: "MetricConfiguration"
  metricId: string
  visualization: Visualization
  groupAttributeId?: string | null
  unit: string
  aggregationInterval: AggregationInterval
  selectedGroups: Array<string>
  groupsAsShareOfTotal?: boolean | null
  filterSelection?: Array<{
    __typename?: "FilterSelection"
    filterAttributeId: string
    filterTermIds: Array<string>
  }> | null
  datespan: {
    __typename?: "MetricDateSpan"
    interval: DateSpanInterval
    startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
    endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
  }
  comparedTo?: {
    __typename?: "ComparedTo"
    relative?: boolean | null
    comparison: {
      __typename?: "Comparison"
      interval?: TimeComparisonInterval | null
      metric?: string | null
    }
  } | null
}

export type ReportFragmentFragment = {
  __typename?: "Report"
  displayName: string
  name: string
  template: boolean
  metrics: Array<{
    __typename?: "MetricConfiguration"
    metricId: string
    visualization: Visualization
    groupAttributeId?: string | null
    unit: string
    aggregationInterval: AggregationInterval
    selectedGroups: Array<string>
    groupsAsShareOfTotal?: boolean | null
    filterSelection?: Array<{
      __typename?: "FilterSelection"
      filterAttributeId: string
      filterTermIds: Array<string>
    }> | null
    datespan: {
      __typename?: "MetricDateSpan"
      interval: DateSpanInterval
      startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
    }
    comparedTo?: {
      __typename?: "ComparedTo"
      relative?: boolean | null
      comparison: {
        __typename?: "Comparison"
        interval?: TimeComparisonInterval | null
        metric?: string | null
      }
    } | null
  }>
}

export type ReportsQueryVariables = Exact<{
  request: SearchReportsRequest
}>

export type ReportsQuery = {
  __typename?: "Query"
  SearchReports: {
    __typename?: "SearchReportsResponse"
    reports: Array<{
      __typename?: "Report"
      displayName: string
      name: string
      template: boolean
      metrics: Array<{
        __typename?: "MetricConfiguration"
        metricId: string
        visualization: Visualization
        groupAttributeId?: string | null
        unit: string
        aggregationInterval: AggregationInterval
        selectedGroups: Array<string>
        groupsAsShareOfTotal?: boolean | null
        filterSelection?: Array<{
          __typename?: "FilterSelection"
          filterAttributeId: string
          filterTermIds: Array<string>
        }> | null
        datespan: {
          __typename?: "MetricDateSpan"
          interval: DateSpanInterval
          startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
          endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        }
        comparedTo?: {
          __typename?: "ComparedTo"
          relative?: boolean | null
          comparison: {
            __typename?: "Comparison"
            interval?: TimeComparisonInterval | null
            metric?: string | null
          }
        } | null
      }>
    }>
    pagination: { __typename?: "PageInfo"; endCursor?: string | null; hasNextPage: boolean }
  }
}

export type TemplateReportsQueryVariables = Exact<{ [key: string]: never }>

export type TemplateReportsQuery = {
  __typename?: "Query"
  listTemplateReports: Array<{
    __typename?: "Report"
    displayName: string
    name: string
    template: boolean
    metrics: Array<{
      __typename?: "MetricConfiguration"
      metricId: string
      visualization: Visualization
      groupAttributeId?: string | null
      unit: string
      aggregationInterval: AggregationInterval
      selectedGroups: Array<string>
      groupsAsShareOfTotal?: boolean | null
      filterSelection?: Array<{
        __typename?: "FilterSelection"
        filterAttributeId: string
        filterTermIds: Array<string>
      }> | null
      datespan: {
        __typename?: "MetricDateSpan"
        interval: DateSpanInterval
        startDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
        endDate?: { __typename?: "Date"; year: number; month: number; day: number } | null
      }
      comparedTo?: {
        __typename?: "ComparedTo"
        relative?: boolean | null
        comparison: {
          __typename?: "Comparison"
          interval?: TimeComparisonInterval | null
          metric?: string | null
        }
      } | null
    }>
  }>
}

export type GroupCountFragment = { __typename?: "GroupCount"; group?: string | null; count: number }

export type CountShipmentLegsQueryVariables = Exact<{
  request: CountShipmentLegsRequest
}>

export type CountShipmentLegsQuery = {
  __typename?: "Query"
  CountShipmentLegs: {
    __typename?: "CountShipmentLegsResponse"
    groupCounts: Array<{ __typename?: "GroupCount"; group?: string | null; count: number }>
  }
}

export type DateTimeFragment = {
  __typename?: "DateTime"
  year: number
  month: number
  day: number
  hours: number
  minutes: number
  seconds: number
}

export type TimestampOrDateFragment = {
  __typename?: "TimestampOrDate"
  timestamp?: any | null
  date?: { __typename?: "Date"; year: number; month: number; day: number } | null
}

export type ShipmentLegFragment = {
  __typename?: "ShipmentLeg"
  deliveredByVehicleDisplayName?: string | null
  deliveryReportedCompleteTime?: any | null
  destinationCity?: string | null
  destinationCountryCode?: string | null
  destinationLocationDisplayName?: string | null
  destinationLocationId?: string | null
  destinationPostalCode?: string | null
  laneDisplayName?: string | null
  laneId?: string | null
  name: string
  originCity?: string | null
  originCountryCode?: string | null
  originLocationDisplayName?: string | null
  originLocationId?: string | null
  originPostalCode?: string | null
  ownerOrganizationName?: string | null
  shipment: string
  space: string
  spaceDisplayName?: string | null
  status?: string | null
  vehicleDriveType?: string | null
  vehicleEnergySource?: string | null
  shipmentExternalReferenceId?: string | null
  shipmentReleaseTime?: any | null
  deliveryReportedCompleteDate?: {
    __typename?: "Date"
    year: number
    month: number
    day: number
  } | null
  deliveryReportedCompleteTimeLocalTimezone?: {
    __typename?: "DateTime"
    year: number
    month: number
    day: number
    hours: number
    minutes: number
    seconds: number
  } | null
  deliveryReportedCompleteAt?: {
    __typename?: "TimestampOrDate"
    timestamp?: any | null
    date?: { __typename?: "Date"; year: number; month: number; day: number } | null
  } | null
}

export type ShipmentLegsQueryVariables = Exact<{
  request: SearchShipmentLegsRequest
}>

export type ShipmentLegsQuery = {
  __typename?: "Query"
  SearchShipmentLegs: {
    __typename?: "SearchShipmentLegsResponse"
    shipmentLegs: Array<{
      __typename?: "ShipmentLeg"
      deliveredByVehicleDisplayName?: string | null
      deliveryReportedCompleteTime?: any | null
      destinationCity?: string | null
      destinationCountryCode?: string | null
      destinationLocationDisplayName?: string | null
      destinationLocationId?: string | null
      destinationPostalCode?: string | null
      laneDisplayName?: string | null
      laneId?: string | null
      name: string
      originCity?: string | null
      originCountryCode?: string | null
      originLocationDisplayName?: string | null
      originLocationId?: string | null
      originPostalCode?: string | null
      ownerOrganizationName?: string | null
      shipment: string
      space: string
      spaceDisplayName?: string | null
      status?: string | null
      vehicleDriveType?: string | null
      vehicleEnergySource?: string | null
      shipmentExternalReferenceId?: string | null
      shipmentReleaseTime?: any | null
      deliveryReportedCompleteDate?: {
        __typename?: "Date"
        year: number
        month: number
        day: number
      } | null
      deliveryReportedCompleteTimeLocalTimezone?: {
        __typename?: "DateTime"
        year: number
        month: number
        day: number
        hours: number
        minutes: number
        seconds: number
      } | null
      deliveryReportedCompleteAt?: {
        __typename?: "TimestampOrDate"
        timestamp?: any | null
        date?: { __typename?: "Date"; year: number; month: number; day: number } | null
      } | null
    }>
    pagination: { __typename?: "PageInfo"; endCursor?: string | null; hasNextPage: boolean }
  }
}

export const FilterFragmentDoc = gql`
  fragment Filter on FilterByRange {
    startYear
    startMonth
  }
`
export const ReportDatumFragmentDoc = gql`
  fragment ReportDatum on Datum {
    key
    values {
      group
      value
    }
  }
`
export const FilterTermFragmentDoc = gql`
  fragment FilterTerm on FilterTerm {
    id
    displayName
  }
`
export const FilterAttributeTermsFragmentDoc = gql`
  fragment FilterAttributeTerms on FilterAttributeTerms {
    filterAttributeId
    filterTerms {
      ...FilterTerm
    }
  }
  ${FilterTermFragmentDoc}
`
export const ComparisonFragmentDoc = gql`
  fragment Comparison on Comparison {
    interval
    metric
  }
`
export const DateFragmentDoc = gql`
  fragment Date on Date {
    year
    month
    day
  }
`
export const DateSpanFragmentDoc = gql`
  fragment DateSpan on MetricDateSpan {
    startDate {
      ...Date
    }
    endDate {
      ...Date
    }
    interval
  }
  ${DateFragmentDoc}
`
export const ReportFragmentDoc = gql`
  fragment Report on Report {
    name
    displayName
    description
    metrics {
      filterSelection {
        filterAttributeId
        filterTermIds
      }
      groupAttributeId
      metricId
      unit
      visualization
      groupsAsShareOfTotal
      comparedTo {
        comparison {
          ...Comparison
        }
        relative
      }
      datespan {
        ...DateSpan
      }
      aggregationInterval
      selectedGroups
    }
    template
  }
  ${ComparisonFragmentDoc}
  ${DateSpanFragmentDoc}
`
export const MetricFragmentDoc = gql`
  fragment Metric on Metric {
    metricId
    availableGroupAttributeIds
    availableFilterAttributeIds
    unit
    comparisons
    metricType
  }
`
export const ReportMetricConfigurationFragmentDoc = gql`
  fragment ReportMetricConfiguration on MetricConfiguration {
    metricId
    visualization
    groupAttributeId
    filterSelection {
      filterAttributeId
      filterTermIds
    }
    unit
    datespan {
      startDate {
        ...Date
      }
      endDate {
        ...Date
      }
      interval
    }
    aggregationInterval
    selectedGroups
    groupsAsShareOfTotal
    comparedTo {
      comparison {
        ...Comparison
      }
      relative
    }
  }
  ${DateFragmentDoc}
  ${ComparisonFragmentDoc}
`
export const ReportFragmentFragmentDoc = gql`
  fragment ReportFragment on Report {
    displayName
    name
    template
    metrics {
      ...ReportMetricConfiguration
    }
  }
  ${ReportMetricConfigurationFragmentDoc}
`
export const GroupCountFragmentDoc = gql`
  fragment GroupCount on GroupCount {
    group
    count
  }
`
export const DateTimeFragmentDoc = gql`
  fragment DateTime on DateTime {
    year
    month
    day
    hours
    minutes
    seconds
  }
`
export const TimestampOrDateFragmentDoc = gql`
  fragment TimestampOrDate on TimestampOrDate {
    timestamp
    date {
      year
      month
      day
    }
  }
`
export const ShipmentLegFragmentDoc = gql`
  fragment ShipmentLeg on ShipmentLeg {
    deliveredByVehicleDisplayName
    deliveryReportedCompleteDate {
      ...Date
    }
    deliveryReportedCompleteTime
    deliveryReportedCompleteTimeLocalTimezone {
      ...DateTime
    }
    deliveryReportedCompleteAt {
      ...TimestampOrDate
    }
    destinationCity
    destinationCountryCode
    destinationLocationDisplayName
    destinationLocationId
    destinationPostalCode
    laneDisplayName
    laneId
    name
    originCity
    originCountryCode
    originLocationDisplayName
    originLocationId
    originPostalCode
    ownerOrganizationName
    shipment
    space
    spaceDisplayName
    status
    vehicleDriveType
    vehicleEnergySource
    shipmentExternalReferenceId
    shipmentReleaseTime
  }
  ${DateFragmentDoc}
  ${DateTimeFragmentDoc}
  ${TimestampOrDateFragmentDoc}
`
export const FilterByRangeDocument = gql`
  query filterByRange($request: FilterByRangeRequest!) {
    filters: filterByRange(request: $request) {
      ...Filter
    }
  }
  ${FilterFragmentDoc}
`

/**
 * __useFilterByRangeQuery__
 *
 * To run a query within a React component, call `useFilterByRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterByRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterByRangeQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useFilterByRangeQuery(
  baseOptions: Apollo.QueryHookOptions<FilterByRangeQuery, FilterByRangeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FilterByRangeQuery, FilterByRangeQueryVariables>(
    FilterByRangeDocument,
    options,
  )
}
export function useFilterByRangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FilterByRangeQuery, FilterByRangeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FilterByRangeQuery, FilterByRangeQueryVariables>(
    FilterByRangeDocument,
    options,
  )
}
export type FilterByRangeQueryHookResult = ReturnType<typeof useFilterByRangeQuery>
export type FilterByRangeLazyQueryHookResult = ReturnType<typeof useFilterByRangeLazyQuery>
export type FilterByRangeQueryResult = Apollo.QueryResult<
  FilterByRangeQuery,
  FilterByRangeQueryVariables
>
export const QueryDataDocument = gql`
  query QueryData($request: QueryDataRequest!) {
    QueryData(request: $request) {
      data {
        ...ReportDatum
      }
    }
  }
  ${ReportDatumFragmentDoc}
`

/**
 * __useQueryDataQuery__
 *
 * To run a query within a React component, call `useQueryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDataQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useQueryDataQuery(
  baseOptions: Apollo.QueryHookOptions<QueryDataQuery, QueryDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QueryDataQuery, QueryDataQueryVariables>(QueryDataDocument, options)
}
export function useQueryDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QueryDataQuery, QueryDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QueryDataQuery, QueryDataQueryVariables>(QueryDataDocument, options)
}
export type QueryDataQueryHookResult = ReturnType<typeof useQueryDataQuery>
export type QueryDataLazyQueryHookResult = ReturnType<typeof useQueryDataLazyQuery>
export type QueryDataQueryResult = Apollo.QueryResult<QueryDataQuery, QueryDataQueryVariables>
export const FilterTermsDocument = gql`
  query filterTerms($request: FilterTermsRequest!) {
    filterTerms(request: $request) {
      ...FilterAttributeTerms
    }
  }
  ${FilterAttributeTermsFragmentDoc}
`

/**
 * __useFilterTermsQuery__
 *
 * To run a query within a React component, call `useFilterTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTermsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useFilterTermsQuery(
  baseOptions: Apollo.QueryHookOptions<FilterTermsQuery, FilterTermsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FilterTermsQuery, FilterTermsQueryVariables>(FilterTermsDocument, options)
}
export function useFilterTermsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FilterTermsQuery, FilterTermsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FilterTermsQuery, FilterTermsQueryVariables>(
    FilterTermsDocument,
    options,
  )
}
export type FilterTermsQueryHookResult = ReturnType<typeof useFilterTermsQuery>
export type FilterTermsLazyQueryHookResult = ReturnType<typeof useFilterTermsLazyQuery>
export type FilterTermsQueryResult = Apollo.QueryResult<FilterTermsQuery, FilterTermsQueryVariables>
export const ReportDocument = gql`
  query Report($request: GetReportRequest!) {
    Report(request: $request) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useReportQuery(
  baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options)
}
export function useReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options)
}
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>
export const CreateReportDocument = gql`
  mutation CreateReport($input: CreateReportRequest!) {
    CreateReport(input: $input) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`
export type CreateReportMutationFn = Apollo.MutationFunction<
  CreateReportMutation,
  CreateReportMutationVariables
>

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(
    CreateReportDocument,
    options,
  )
}
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<
  CreateReportMutation,
  CreateReportMutationVariables
>
export const UpdateReportDocument = gql`
  mutation UpdateReport($input: UpdateReportRequest!) {
    UpdateReport(input: $input) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`
export type UpdateReportMutationFn = Apollo.MutationFunction<
  UpdateReportMutation,
  UpdateReportMutationVariables
>

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(
    UpdateReportDocument,
    options,
  )
}
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<
  UpdateReportMutation,
  UpdateReportMutationVariables
>
export const DuplicateReportDocument = gql`
  mutation DuplicateReport($input: DuplicateReportRequest!) {
    DuplicateReport(input: $input) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`
export type DuplicateReportMutationFn = Apollo.MutationFunction<
  DuplicateReportMutation,
  DuplicateReportMutationVariables
>

/**
 * __useDuplicateReportMutation__
 *
 * To run a mutation, you first call `useDuplicateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateReportMutation, { data, loading, error }] = useDuplicateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateReportMutation,
    DuplicateReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateReportMutation, DuplicateReportMutationVariables>(
    DuplicateReportDocument,
    options,
  )
}
export type DuplicateReportMutationHookResult = ReturnType<typeof useDuplicateReportMutation>
export type DuplicateReportMutationResult = Apollo.MutationResult<DuplicateReportMutation>
export type DuplicateReportMutationOptions = Apollo.BaseMutationOptions<
  DuplicateReportMutation,
  DuplicateReportMutationVariables
>
export const DeleteReportDocument = gql`
  mutation DeleteReport($input: DeleteReportRequest!) {
    DeleteReport(input: $input) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`
export type DeleteReportMutationFn = Apollo.MutationFunction<
  DeleteReportMutation,
  DeleteReportMutationVariables
>

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(
    DeleteReportDocument,
    options,
  )
}
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteReportMutation,
  DeleteReportMutationVariables
>
export const AvailableMetricsDocument = gql`
  query availableMetrics($request: GetAvailableMetricsRequest!) {
    availableMetrics(request: $request) {
      ...Metric
    }
  }
  ${MetricFragmentDoc}
`

/**
 * __useAvailableMetricsQuery__
 *
 * To run a query within a React component, call `useAvailableMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAvailableMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<AvailableMetricsQuery, AvailableMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AvailableMetricsQuery, AvailableMetricsQueryVariables>(
    AvailableMetricsDocument,
    options,
  )
}
export function useAvailableMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AvailableMetricsQuery, AvailableMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AvailableMetricsQuery, AvailableMetricsQueryVariables>(
    AvailableMetricsDocument,
    options,
  )
}
export type AvailableMetricsQueryHookResult = ReturnType<typeof useAvailableMetricsQuery>
export type AvailableMetricsLazyQueryHookResult = ReturnType<typeof useAvailableMetricsLazyQuery>
export type AvailableMetricsQueryResult = Apollo.QueryResult<
  AvailableMetricsQuery,
  AvailableMetricsQueryVariables
>
export const ReportsDocument = gql`
  query reports($request: SearchReportsRequest!) {
    SearchReports(request: $request) {
      reports {
        ...ReportFragment
      }
      pagination {
        endCursor
        hasNextPage
      }
    }
  }
  ${ReportFragmentFragmentDoc}
`

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useReportsQuery(
  baseOptions: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options)
}
export function useReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options)
}
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>
export const TemplateReportsDocument = gql`
  query templateReports {
    listTemplateReports {
      ...ReportFragment
    }
  }
  ${ReportFragmentFragmentDoc}
`

/**
 * __useTemplateReportsQuery__
 *
 * To run a query within a React component, call `useTemplateReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplateReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<TemplateReportsQuery, TemplateReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TemplateReportsQuery, TemplateReportsQueryVariables>(
    TemplateReportsDocument,
    options,
  )
}
export function useTemplateReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TemplateReportsQuery, TemplateReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TemplateReportsQuery, TemplateReportsQueryVariables>(
    TemplateReportsDocument,
    options,
  )
}
export type TemplateReportsQueryHookResult = ReturnType<typeof useTemplateReportsQuery>
export type TemplateReportsLazyQueryHookResult = ReturnType<typeof useTemplateReportsLazyQuery>
export type TemplateReportsQueryResult = Apollo.QueryResult<
  TemplateReportsQuery,
  TemplateReportsQueryVariables
>
export const CountShipmentLegsDocument = gql`
  query countShipmentLegs($request: CountShipmentLegsRequest!) {
    CountShipmentLegs(request: $request) {
      groupCounts {
        ...GroupCount
      }
    }
  }
  ${GroupCountFragmentDoc}
`

/**
 * __useCountShipmentLegsQuery__
 *
 * To run a query within a React component, call `useCountShipmentLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountShipmentLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountShipmentLegsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCountShipmentLegsQuery(
  baseOptions: Apollo.QueryHookOptions<CountShipmentLegsQuery, CountShipmentLegsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CountShipmentLegsQuery, CountShipmentLegsQueryVariables>(
    CountShipmentLegsDocument,
    options,
  )
}
export function useCountShipmentLegsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountShipmentLegsQuery,
    CountShipmentLegsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CountShipmentLegsQuery, CountShipmentLegsQueryVariables>(
    CountShipmentLegsDocument,
    options,
  )
}
export type CountShipmentLegsQueryHookResult = ReturnType<typeof useCountShipmentLegsQuery>
export type CountShipmentLegsLazyQueryHookResult = ReturnType<typeof useCountShipmentLegsLazyQuery>
export type CountShipmentLegsQueryResult = Apollo.QueryResult<
  CountShipmentLegsQuery,
  CountShipmentLegsQueryVariables
>
export const ShipmentLegsDocument = gql`
  query shipmentLegs($request: SearchShipmentLegsRequest!) {
    SearchShipmentLegs(request: $request) {
      shipmentLegs {
        ...ShipmentLeg
      }
      pagination {
        endCursor
        hasNextPage
      }
    }
  }
  ${ShipmentLegFragmentDoc}
`

/**
 * __useShipmentLegsQuery__
 *
 * To run a query within a React component, call `useShipmentLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentLegsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useShipmentLegsQuery(
  baseOptions: Apollo.QueryHookOptions<ShipmentLegsQuery, ShipmentLegsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ShipmentLegsQuery, ShipmentLegsQueryVariables>(
    ShipmentLegsDocument,
    options,
  )
}
export function useShipmentLegsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShipmentLegsQuery, ShipmentLegsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ShipmentLegsQuery, ShipmentLegsQueryVariables>(
    ShipmentLegsDocument,
    options,
  )
}
export type ShipmentLegsQueryHookResult = ReturnType<typeof useShipmentLegsQuery>
export type ShipmentLegsLazyQueryHookResult = ReturnType<typeof useShipmentLegsLazyQuery>
export type ShipmentLegsQueryResult = Apollo.QueryResult<
  ShipmentLegsQuery,
  ShipmentLegsQueryVariables
>

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
}
export default result
